module.exports = __webpack_public_path__ + "media/images/icons/bell-8f8889d91cc357c73833e8e9060c118f.svg";